import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { changeToCoin, changeToNumber } from 'helpers/utils';
import Input from 'components/common/Input';
import IconButton from 'components/common/IconButton';

const indications = [
 {
  name: 'name',
  title: 'NOMBRE',
  body: `Establezca un monbre a la configuracion del financiamiento, el cual debera especificar en el excel en cada producto en el que desee tal configuracion y asi en el momento de la separacion este parametrizada con dicha configuracion.`
 },
 {
  name: 'initialFee',
  title: 'CUOTA INICIAL',
  body: `Establezca un porcentage que represente el valor de la cuota inicial de cada producto en el proyecto. El pocentage que se pretenda establecer debe ser dividido entre 100 ejp: 50% = 0.5%`
 },
 {
  name: 'maxInitials',
  title: 'CUOTAS DE INICIAL',
  body: `Establezca un numero de cuotas en la que podra definir el pago de la cuota inicial en una orden. El numero de cuotas representan el numero de meses que tardara un cliente en pagar el monto prestablecido.`
 },
 {
  name: 'maxFinancing',
  title: 'CUOTAS DE FINANCIACION',
  body: `Establezca un numero de cuotas en la que podra definir el pago total de un producto, tenga en cuenta que en este numero se incluyen las cuotas que se hallan establecido en la cuota inicial. El numero de cuotas representan el numero de meses que tardara un cliente en pagar el monto prestablecido.`
 },
 {
  name: 'minFee',
  title: 'CUOTA MINIMA',
  body: `Establezca un monto minimo para cada cuota que se establezca, si el numero de la finaciacion afecta el monto minimo de las cuotas este se cambiara ala financiiacion mas cercano que cumpla con la cuota minima.`
 },
 {
  name: 'minInitialPay',
  title: 'SEPARACION',
  body: `Establezca un monto o porcentage minimo para la separacion de un producto, este corresponde al valor inicial requerido para la creacion de una orden y ara parte del valor de la cuota inicial. Si el valor establecido es menor a 1 se tomara de manera porcentual, en este caso si pretende establecer pocentage debe dividir entre 100 el porcentage deseado ejp: si desea establecer el 50% debe poner 0.5% asi sera siempre menor a 1`
 },
 {
  name: 'incentive',
  title: 'INCENTIVO',
  body: `Establezca un monto o porcentage minimo para dar como incentivo al asesor por la separacion de un producto, recuerde que este es un valor para incentivar la venta y no tiene que ver con la comision prestablecida de un asesor. Si el valor establecido es menor a 1 se tomara de manera porcentual, en este caso si pretende establecer pocentage debe dividir entre 100 el porcentage deseado ejp: si desea establecer el 50% debe poner 0.5% asi sera siempre menor a 1`
 },
 {
  name: 'lateFee',
  title: 'MORA',
  body: `Establezca un numero que sera el plazo de meses vencidos que tendra un cliente para ponerse al dia con el pago de sus cuotas atrasadas, pasado este tiempo el sistema generara un interes de mora en las cuotas vencidas. Si se deja en 0 el sistema no generara intereses por mora`
 }
];

const defaultValues = {
 name: null,
 minInitialPay: null,
 initialFee: null,
 maxInitials: null,
 minFeeIni: null,
 maxFinancing: null,
 minFeeFnc: null,
 lateFee: null,
 rate: null,
 amortize: null
};

const currencyFields = ['minFeeFnc', 'minInitialPay', 'initialFee', 'minFeeIni', 'rate'];

const FinancingForm = ({ financing, append, update, fields, setOpen }) => {
 const {
  reset,
  watch,
  register,
  setValue,
  handleSubmit,
  formState: { errors }
 } = useForm({ defaultValues });

 const [amount, setAmount] = useState({});

 useEffect(() => {
  console.log('cambio la financiacion', financing);
  reset({ ...defaultValues, ...financing });
 }, [financing]);

 useEffect(() => {
  const subscription = watch((value, { name }) => {
   console.log(value, 'el formulario cambio', name);

   if (name === undefined)
    currencyFields.forEach(e =>
     setAmount(data => ({ ...data, [e]: changeToCoin({ amount: value[e], symbol: true, cents: true }) }))
    );

   if (currencyFields.some(e => e === name)) {
    setAmount(data => ({ ...data, [name]: changeToCoin({ amount: value[name], symbol: true, cents: true }) }));
   }
  });
  return () => subscription.unsubscribe();
 }, [watch]);

 const onChange = ({ target: { name, value } }) =>
  setValue(name, changeToNumber({ amount: value, cents: true }), { shouldValidate: true });

 const onSubmitData = newD => {
  const { index, ...newData } = newD;

  if (index) update(index, newData);
  else append(newData);

  return reset(defaultValues);
 };

 const onError = err => console.log('se genero un error en el formulario', err);

 return (
  <>
   <Row className="g-2 mt-3">
    <Input
     type="text"
     name="name"
     label="Nombre"
     errors={errors}
     placeholder="Financiamiento"
     help={indications.find(e => e.name === 'name')}
     formGroupProps={{ className: 'col-8 col-md-4' }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('name', {
       required: 'Campo requerido',
       validate: value => {
        const uno = !/[^a-z0-9_-]/g.test(value) || 'Caracteres invalidos';
        const dos = !fields?.some(e => e.name === value && value !== financing?.name) || 'Nombre ya existe';
        return typeof uno === 'boolean' ? dos : uno;
       },
       minLength: {
        value: 5,
        message: 'Pocos caracteres'
       }
      }),
      className: 'text-center',
      autoComplete: 'off',
      maxLength: 20,
      size: 'sm'
     }}
    />

    <Input
     type="text"
     errors={errors}
     name="maxFinancing"
     placeholder="Meses"
     label="Cuotas"
     help={indications.find(e => e.name === 'maxFinancing')}
     formGroupProps={{ className: 'col-4 col-md-2' }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('maxFinancing', {
       required: 'requerido',
       validate: value => (!isNaN(value) && parseFloat(value) > 0) || 'Debe ser > 0'
      }),
      className: 'text-center',
      size: 'sm'
     }}
    />

    <Input
     type="text"
     name="minFeeFnc"
     errors={errors}
     label="Cuota min."
     placeholder="Monto minimo"
     help={indications.find(e => e.name === 'maxFinancing')}
     formGroupProps={{ className: 'col-6 col-md-3' }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      name: 'minFeeFnc',
      className: 'text-center',
      size: 'sm',
      onFocus: e => e.target.select(),
      value: amount?.minFeeFnc ?? '',
      onChange
     }}
    />

    <Input
     type="hidden"
     formControlProps={{
      ...register('minFeeFnc', {
       required: true,
       validate: value => (!isNaN(value) && parseFloat(value) > 0) || 'Debe ser > 0'
      })
     }}
    />

    <Input
     type="text"
     errors={errors}
     label="Separacion"
     name="minInitialPay"
     placeholder="Monto de separacion"
     help={indications.find(e => e.name === 'minInitialPay')}
     formGroupProps={{ className: 'col-6 col-md-3' }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      name: 'minInitialPay',
      className: 'text-center',
      autoComplete: 'off',
      size: 'sm',
      onFocus: e => e.target.select(),
      value: amount?.minInitialPay ?? '',
      onChange
     }}
    />

    <Input
     type="hidden"
     formControlProps={{
      ...register('minInitialPay', {
       required: true,
       validate: value => (!isNaN(value) && parseFloat(value) > 0) || 'Debe ser > 0'
      })
     }}
    />

    <Input
     type="text"
     errors={errors}
     label="Inicial"
     name="initialFee"
     placeholder="0.0%"
     help={indications.find(e => e.name === 'initialFee')}
     formGroupProps={{ className: 'col-4' }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      name: 'initialFee',
      className: 'text-center',
      autoComplete: 'off',
      size: 'sm',
      onFocus: e => e.target.select(),
      value: amount?.initialFee ?? '',
      onChange
     }}
    />

    <Input
     type="hidden"
     formControlProps={{
      ...register('initialFee', { required: true, validate: value => (!isNaN(value) && parseFloat(value) > 0) || 'Debe ser > 0' })
     }}
    />

    <Input
     type="text"
     errors={errors}
     name="maxInitials"
     label="Diferir"
     placeholder="Meses"
     help={indications.find(e => e.name === 'maxInitials')}
     formGroupProps={{ className: 'col-4' }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('maxInitials', {
       required: 'requerido',
       validate: value => !isNaN(value) || 'Deve ser num'
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      size: 'sm'
     }}
    />

    <Input
     type="text"
     name="minFeeIni"
     errors={errors}
     label="Cta. min."
     placeholder="Monto minimo"
     help={indications.find(e => e.name === 'minFee')}
     formGroupProps={{ className: 'col-4' }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      name: 'minFeeIni',
      className: 'text-center',
      autoComplete: 'off',
      size: 'sm',
      onFocus: e => e.target.select(),
      value: amount?.minFeeIni ?? '',
      onChange
     }}
    />

    <Input
     type="hidden"
     formControlProps={{
      ...register('minFeeIni', { required: true, validate: value => (!isNaN(value) && parseFloat(value) > 0) || 'Debe ser > 0' })
     }}
    />

    <Input
     type="text"
     label="Mora"
     name="lateFee"
     errors={errors}
     placeholder="Meses"
     help={indications.find(e => e.name === 'lateFee')}
     formGroupProps={{ className: 'col-4' }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('lateFee', {
       setValueAs: v => (!isNaN(v) && !!v ? v : 0)
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      size: 'sm'
     }}
    />

    <Input
     type="text"
     name="rate"
     label="Tasa"
     errors={errors}
     placeholder="0%"
     help={indications.find(e => e.name === 'lateFee')}
     formGroupProps={{ className: 'col-4' }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      name: 'rate',
      className: 'text-center',
      autoComplete: 'off',
      size: 'sm',
      onFocus: e => e.target.select(),
      value: amount?.rate ?? '',
      onChange
     }}
    />

    <Input
     type="text"
     name="amortize"
     errors={errors}
     label="Amtzr"
     placeholder="Meses"
     help={indications.find(e => e.name === 'lateFee')}
     formGroupProps={{ className: 'col-4' }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('amortize', {
       setValueAs: v => (!isNaN(v) && !!v ? v : 0)
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      size: 'sm'
     }}
    />
   </Row>

   <IconButton
    size="sm"
    icon={financing?.index ? 'redo-alt' : 'plus'}
    transform="shrink-3"
    className="float-end mt-3"
    variant="falcon-success"
    onClick={() => handleSubmit(onSubmitData, onError)()}
   >
    {financing?.index ? 'Actualizar' : 'Crear'}
   </IconButton>

   <IconButton
    type="button"
    size="sm"
    icon="eye-slash"
    transform="shrink-3"
    className="mt-3 me-3"
    variant="falcon-default"
    onClick={() => {
     setOpen(false);
     const element = document.getElementById('listFnc');
     if (element) element.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }}
   />

   <IconButton
    type="reset"
    size="sm"
    icon="ban"
    transform="shrink-3"
    className="mt-3"
    variant="falcon-danger"
    onClick={() => reset(defaultValues)}
   >
    Cancelar
   </IconButton>
  </>
 );
};

FinancingForm.propTypes = {
 financing: PropTypes.object,
 fields: PropTypes.array,
 append: PropTypes.func,
 update: PropTypes.func,
 setOpen: PropTypes.func
};

FinancingForm.defaultProps = { financings: [] };

export default FinancingForm;
